export default __webpack_public_path__ + "static/media/employee-card.239cc15f.png";